(() => {
  const PRODUCT_SLOT_SELECTOR = '[data-product-wishlist-slot]';
  const observedShadowRoots = new WeakSet();

  const productShadowStyle = `
      :host {
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: inherit !important;
        font: inherit !important;
      }
      *, *::before, *::after { box-sizing: border-box !important; }
      :host > * {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
      }
      button, a, [role='button'] {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 16px !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: inherit !important;
        font: inherit !important;
      }
      span:not([class*='WishlistButton__Icon']), p {
        display: inline !important;
        flex: 0 0 auto !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        background: transparent !important;
        color: inherit !important;
        font: inherit !important;
        white-space: nowrap !important;
      }
      [class*='WishlistButton__Icon'] {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 24px !important;
        width: 24px !important;
        height: 24px !important;
        min-width: 24px !important;
        min-height: 24px !important;
        margin: 0 !important;
        padding: 0 !important;
        line-height: 0 !important;
      }
      svg, img { display: block !important; flex: 0 0 auto !important; width: 24px !important; height: 24px !important; }
      button:focus-visible, a:focus-visible, [role='button']:focus-visible {
        outline: 2px solid currentColor !important;
        outline-offset: -3px !important;
      }
      @media (max-width: 1023px) {
        [class*='WishlistButton__Icon'] {
          flex-basis: 20px !important;
          width: 20px !important;
          height: 20px !important;
          min-width: 20px !important;
          min-height: 20px !important;
        }
        svg, img { width: 20px !important; height: 20px !important; }
      }
    `;

  const observeShadowRoot = (root, type) => {
    if (observedShadowRoots.has(root)) return;
    observedShadowRoots.add(root);
    const observer = new MutationObserver(() => injectShadowStyle(root, type));
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };

  const injectShadowStyle = (root, type) => {
    if (!root || type !== 'product') return false;

    const marker = `style[data-tl-joy-shadow-style='${type}']`;
    if (!root.querySelector(marker)) {
      const style = document.createElement('style');
      style.dataset.tlJoyShadowStyle = type;
      style.textContent = productShadowStyle;
      root.prepend(style);
    }

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) injectShadowStyle(element.shadowRoot, type);
    });
    observeShadowRoot(root, type);
    return true;
  };

  const styleProductWishlistSlot = (slot) => {
    if (!(slot instanceof Element)) return;
    slot.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) injectShadowStyle(element.shadowRoot, 'product');
    });
    [0, 100, 400, 1000, 2000].forEach((delay) => {
      window.setTimeout(() => {
        slot.querySelectorAll('*').forEach((element) => {
          if (element.shadowRoot) injectShadowStyle(element.shadowRoot, 'product');
        });
      }, delay);
    });
  };

  const scanProductWishlistSlots = (scope = document) => {
    if (scope instanceof Element && scope.matches(PRODUCT_SLOT_SELECTOR)) styleProductWishlistSlot(scope);
    scope.querySelectorAll?.(PRODUCT_SLOT_SELECTOR).forEach(styleProductWishlistSlot);
  };

  const initialize = () => {
    scanProductWishlistSlots();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          scanProductWishlistSlots(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scanProductWishlistSlots(event.target);
  });
})();
